<div [ngClass]="baseService.isMobile ? 'd-flex flex-column gap-2 align-items-start' : 'd-flex align-items-center'">
  <app-search (onValueChange)="onSearchChange($event)"></app-search>
  <!--  <app-dropdown-->
  <!--    [ngClass]="baseService.isMobile ? 'mx-0' : 'mx-2'"-->
  <!--    style="width: 250px;"-->
  <!--    [items]="filterStatuses"-->
  <!--    [placeholder]="'filter_by_status' | translate"-->
  <!--    [clearable]="true"-->
  <!--    (onValueChange)="onFilterChange('status', $event)"-->
  <!--    [closeOnSelect]="true"-->
  <!--    [isTranslate]="true"-->
  <!--  ></app-dropdown>-->
  @if (selectionTable.selected.length) {
    <div>
      <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <span class="selected_dropdown">({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span>
          <app-icon class="align-middle selected_dropdown">{{ t.menuOpen ? 'expand_less' : 'expand_more' }} </app-icon>
        </div>
      </app-button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
        @for (item of bulkActionList; track item; let i = $index) {
          <button mat-menu-item (click)="bulkActionPopup(item)">
            {{ item.label | translate }}
          </button>
        }
      </mat-menu>
    </div>
  }
  @if (!baseService.isMobile) {
    <div class="flex-fill"></div>
  }
  <div
    class="d-flex gap-2 align-items-center"
    [ngClass]="{ 'justify-content-between': baseService.isMobile, 'w-100 flex-wrap': baseService.isMobile }"
  >
    <app-button (onChangeClick)="buyPackage()">{{ 'buy_package' | translate }}</app-button>
    @if (balance) {
      <div class="d-flex flex-column text-black fs-sm">
        <div>{{ 'your_account_information' | translate }}: {{ balance?.sum }} {{ 'UAH' | translate }}.</div>
        <div>{{ 'available_balance' | translate }}: {{ balance?.bonus }} {{ 'bonuses' | translate }}</div>
      </div>
    }
    <app-dropdown
      class="account-box"
      [ngClass]="{ 'w-100': baseService.isMobile }"
      [items]="items || []"
      [input]="currentChannelId || {}"
      [bindValue]="'id'"
      (onValueChange)="onValueChange($event)"
      [closeOnSelect]="true"
      [searchable]="true"
      placeholder="{{ 'channels' | translate }}"
    />
  </div>
  <!--        <app-button (onChangeClick)="openDialogCreateChannel()">Створити канал</app-button>-->
</div>
<div class="d-flex justify-content-between align-items-center">
  @if (filterStatuses?.length) {
    <div
      class="mt-2 d-flex justify-content-between gap-2 flex-wrap"
      [ngClass]="{ 'justify-content-center': baseService.isMobile }"
    >
      @for (item of filterStatuses; track item) {
        <h5 class="text-black">
          @if (statistic) {
            <div
              class="badge btn-static click-css"
              [ngStyle]="{ '--color': item.active ? item.color : '#cccccc' }"
              (click)="onFilterChange('status', item)"
            >
              {{ item.name | translate }}: {{ statistic[item.key] ? statistic[item.key] : '0' }}
            </div>
          }
        </h5>
      }
    </div>
  }
  <div>
    <app-button (onChangeClick)="createAdvert()">Створити</app-button>
  </div>
</div>

@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <app-table
      class="w-100"
      [dataSource]="dataSource"
      [visibleColumnKeys]="visibleColumns"
      (onSortChange)="onSortChange($event)"
      (onPaginationChange)="onPaginationChange($event)"
      (menuSelected)="onActionChange($event)"
      [showUpPagination]="true"
      [selection]="selectionTable"
      (onTableRowClick)="changeAdvert($event.row)"
    ></app-table>
  }
}
